module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/ohio-univ-31df52dd4b0fafb3953ae5de1890a8e5.svg";